import { CardServiceInstantComponent } from '../../components/card-service-instant/card-service-instant.component';
import { CardServiceComponent } from '../../components/card-service/card-service.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import BusinessRestServices from '../../services/business-rest.service';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'list-services-instant',
	templateUrl: './list-services-instant.component.html',
	imports: [ CommonModule, CardServiceInstantComponent, CardServiceComponent, FormsModule ]
})
export class ListServicesInstantComponent implements OnInit, OnDestroy {
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	vm: any = undefined;
	currentServiceCount: number = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.user = this.session.getSession().user;
		this.vm.params = this.angularRoutingHelperService.getQueryParams() || {};
		
		this.getServices().then(() => {
			this.broadcastSubscriptions.push(
				this.angularBroadcastHelperService.onEvent(this,
					this.config.getBroadcastConfig().Services.SEARCH, (e, data) => { this.handleSearchUpdate(e, data); })
			);
		});
	}
	
	ngOnDestroy() {
		if (this.vm.intervalTimer) {
			this.angularHelperService.cancelInterval(this.vm.intervalTimer);
		}
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	getServices() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		var params: any = {
			origin: this.session.getSession().user.origin
		}
		this.vm.lowerAuthSupportRequired = !this.session.getSession().user.personalCode;
		
		this.businessRestServices.getOnDemandSettings(params, (settings) => {
			var prescription: any = settings.filter(function(item) { return item.subcategory === 'GENERAL_MEDICAL_PRACTICE' && !item.furtherSubcategory })[0];
			var general: any = settings.filter(function(item) { return item.subcategory === 'GENERAL_MEDICAL_PRACTICE' && item.furtherSubcategory === 'FAMILY_PHYSICIAN' })[0];
			var mental: any = settings.filter(function(item) { return item.subcategory === 'GENERAL_MEDICAL_PRACTICE' && item.furtherSubcategory === 'MENTAL_CHECK' })[0];
			var pharmacist: any = settings.filter(function(item) { return item.subcategory === 'PHARMACIST' && item.furtherSubcategory === 'PHARMACIST' })[0];
			var symptomChecker: any = settings.filter(function(item) { return item.subcategory === 'GENERAL_MEDICAL_PRACTICE' && item.furtherSubcategory === 'SYMPTOM_CHECK' })[0];
			var weightLoss: any = settings.filter(function(item) { return item.subcategory === 'GENERAL_MEDICAL_PRACTICE' && item.furtherSubcategory === 'WEIGHT_LOSS_CONSULTATION' })[0];
			var services: any = {};

			if (weightLoss && this.vm.user.origin !== 'siffi.com') {
				weightLoss.subcategory = 'WEIGHT_LOSS_CONSULTATION';
				weightLoss.searchSubcategories = [undefined, 'GENERAL_MEDICAL_PRACTICE', 'WEIGHT_LOSS_CONSULTATION'];
				weightLoss.checkAvailability = false;
				weightLoss.lowerAuthenticationSupported = true;
				weightLoss.enabled = true;
				services.weightLoss = weightLoss;
			}

			if (prescription) {
				prescription.subcategory = 'PRESCRIPTION';
				prescription.searchSubcategories = [undefined, 'GENERAL_MEDICAL_PRACTICE', 'FAMILY_PHYSICIAN'];
				prescription.generalPractitionerSpecialCheck = 'prescriptionsOnly';
				services.prescription = prescription;
			}
			if (general) {
				general.searchSubcategories = [undefined, 'GENERAL_MEDICAL_PRACTICE', 'FAMILY_PHYSICIAN'];
				general.checkAvailability = true;
				general.generalPractitionerSpecialCheck = 'gpOnly';
				services.general = general;
			}
			if (mental) {
				mental.subcategory = 'MENTAL_CHECK';
				mental.searchSubcategories = [undefined, 'GENERAL_MEDICAL_PRACTICE', 'MENTAL_CHECK'];
				mental.checkAvailability = false;
				mental.isMentalHealth = true;
				services.mental = mental;
			}
			if (pharmacist) {
				pharmacist.searchSubcategories = [undefined, 'PHARMACIST'];
				pharmacist.checkAvailability = true;
				services.pharmacist = pharmacist;
			}
			var symCheckContainer: any = document.getElementById('symptom-checker-container');
			if (symCheckContainer) {
				if (symptomChecker && symptomChecker.enabled && (!this.vm.lowerAuthSupportRequired || symptomChecker.lowerAuthenticationSupported)) {
					symCheckContainer.style.visibility = 'visible';
				} else {
					symCheckContainer.style.visibility = 'hidden';
				}
			}

			this.addCoachingCardForMinudoc(services);

			this.determineToShowPreVisitCard(services).then(() => {
				this.handleServicesAvailability();
			}).then(() => {
				deferred.resolve();
			})
		});
		
		return deferred.promise;
	}
	
	determineToShowPreVisitCard(services) {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		if (!this.vm.user.personalCode) {
			deferred.resolve();
		}
		var preVisitData: any = {};
		preVisitData.subcategory = 'PRE_VISIT';
		preVisitData.searchSubcategories = [undefined, 'GENERAL_MEDICAL_PRACTICE', 'FAMILY_PHYSICIAN'];
		preVisitData.lowerAuthenticationSupported = false;
		preVisitData.enabled = true;
		preVisitData.isAllowed = true;
		services = Object.assign({'pre-visit': preVisitData}, services);

		if (this.isPartnersSupported()) {
			var partnersData: any = {};
			partnersData.subcategory = 'PARTNERS';
			partnersData.searchSubcategories = [undefined];
			partnersData.lowerAuthenticationSupported = true;
			partnersData.enabled = true;
			partnersData.isAllowed = true;
			partnersData.checkAvailability = false;
			services = Object.assign({'partners': partnersData}, services);
		}
		
		this.vm.services = services;
		this.vm.serviceNames = Object.keys(this.vm.services);
		deferred.resolve();
		return deferred.promise;
	}

	isPartnersSupported() {
		return this.vm.user.origin === 'minudoc.ee'
			&& this.vm.user.parentBusinessUser
			&& this.vm.user.parentBusinessUser.service
			&& this.vm.user.parentBusinessUser.service.partnersEnabled === true;
	}
	
	addCoachingCardForMinudoc(services) {
		if (this.vm.user.origin == 'siffi.com') {
			return;
		}
		var coachingData: any = {};
		coachingData.subcategory = 'COACHING_TOPICS';
		coachingData.searchSubcategories = [undefined, 'GENERAL_MEDICAL_PRACTICE', 'COACHING_TOPICS'];
		coachingData.lowerAuthenticationSupported = true;
		coachingData.enabled = true;
		coachingData.isAllowed = true;
		services.coachingTopics = coachingData;
	}

	addWeightLossServiceCardForMinudoc(services) {
		if (this.vm.user.origin == 'siffi.com') {
			return;
		}
		var weightLoss: any = {};
		weightLoss.subcategory = 'WEIGHT_LOSS_CONSULTATION';
		weightLoss.searchSubcategories = [undefined, 'GENERAL_MEDICAL_PRACTICE', 'WEIGHT_LOSS_CONSULTATION'];
		weightLoss.checkAvailability = false;
		weightLoss.lowerAuthenticationSupported = true;
		weightLoss.enabled = true;
		weightLoss.isAllowed = true;
		services.weightLoss = weightLoss;
	}

	getAvailableServicesCount() {
		return this.vm.serviceNames
			.map((name) => { return this.vm.services[name]; })
			.filter((service) => { return service.isAllowed && service.enabled && (!this.vm.lowerAuthSupportRequired || service.lowerAuthenticationSupported); })
			.length;
	}
	
	handleServicesAvailability() {
		this.vm.serviceNames.forEach((name) => {
			this.handleServiceAvailability(this.vm.services[name]);
		});
	}
	
	handleServiceAvailability(service) {
		var queryParams: any = this.angularRoutingHelperService.getQueryParams();
		if (Object.keys(queryParams).length) {
			service.isAllowed = false;
			service.enabled = false;
			return;
		} else {
			service.enabled = true;
		}
		
		if (service.isMentalHealth) {
			service.isAllowed = true;
			return;
		}
		
		var category: any = queryParams.category;
		var languages: any = queryParams.lang;
		
		var isAllowed: any = service.searchSubcategories.indexOf(category) !== -1 && !this.config.isOnDemandServiceUnavailable(service);
		
		if (!isAllowed) {
			service.isAllowed = isAllowed;
			return;
		}
		if (!service.checkAvailability) {
			service.isAllowed = true;
			return;
		}
		
		var searchParams: any = {
			subcategory: service.subcategory,
			origin: this.session.getSession().user.origin
		};
		if (languages) searchParams.languages = languages;
		
		if (service.enabled) {
			this.businessRestServices.getInstantlyAvailable(searchParams, (res) => {
				service.isAllowed = !!res;
			}, (err) => {
				console.error(err);
				service.isAllowed = false;
			});
		} else {
			service.isAllowed = false;
		}
	}
	
	handleSearchUpdate(e, data) {
		console.log('Broadcast event: ' + e.name + ' in component/list-services-instant, triggered from: ' + data.origin);
		this.vm.params = this.angularRoutingHelperService.getQueryParams() || {};
		this.handleServicesAvailability();
	}
	
}
